"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsMockStates = void 0;
var SettingsMockStates;
(function (SettingsMockStates) {
    // Modify account state
    SettingsMockStates["CANCEL_ELIGIBILITY_ERROR"] = "cancelEligibilityError";
    SettingsMockStates["DELETE_ELIGIBILITY_FAIL_V2"] = "deleteEligibilityFailV2";
    SettingsMockStates["RESUME_FAILED"] = "resumeFailed";
    SettingsMockStates["UNPAUSE_AUTOPAY_FAILURE"] = "unpauseAutopayFailure";
    // Rent reporting
    SettingsMockStates["OPTED_OUT_RENT_REPORTING"] = "optedOutRentReporting";
    // Agreements
    SettingsMockStates["IN_APP_REQUIRED_AGREEMENT_PENDING"] = "inAppRequiredAgreementPending";
    // Property
    SettingsMockStates["RELINK_INELIGIBLE"] = "relinkIneligible";
    // Payment Schedule
    SettingsMockStates["FLEX_LITE"] = "flexLite";
    // Payment method - Card
    SettingsMockStates["SETUP_CARD_NEW_CARD"] = "setupCardNewCard";
    SettingsMockStates["SETUP_CARD_CAPITAL_ONE_FAILURE"] = "setupCardCapitalOneFailure";
    SettingsMockStates["SETUP_CARD_GENERIC_FAILURE"] = "setupCardGenericFailure";
    SettingsMockStates["SETUP_CARD_GENERIC_FAILURE_ONBOARDING"] = "setupCardGenericFailureOnboarding";
    SettingsMockStates["SETUP_CARD_V2_CARD_LINKAGE_FAIL"] = "setupCardV2CardLinkageFail";
    // Payment method - Wallet
    SettingsMockStates["WALLET_DISABLED"] = "walletDisabled";
    SettingsMockStates["USER_WALLET_INELIGIBLE"] = "userWalletIneligible";
    SettingsMockStates["ADD_WITHDRAW_RATE_LIMIT"] = "addWithdrawRateLimit";
    SettingsMockStates["ADD_WITHDRAW_FUNDS_GENERIC_ERRORS"] = "addWithdrawFundsGenericErrors";
    SettingsMockStates["ADD_WITHDRAW_SPECIAL_FAILURES"] = "addWithdrawSpecialFailures";
    // Wallet - Withdraw funds
    SettingsMockStates["WITHDRAW_FUNDS_SUCCESS"] = "withdrawFundsSuccess";
    SettingsMockStates["WITHDRAW_FUNDS_MAX_WITHDRAWALS"] = "withdrawFundsMaxWithdrawals";
    SettingsMockStates["WITHDRAW_FUNDS_RENT_PAYMENT_PROCESSING"] = "withdrawFundRentPaymentProcessing";
    SettingsMockStates["WITHDRAW_FUNDS_10_SECOND_WAIT"] = "withdrawFunds10SecondWait";
    SettingsMockStates["WITHDRAW_FUNDS_WITHDRAWAL_IN_PROGRESS"] = "withdrawFundsWithdrawalInProgress";
    // Wallet - Add funds
    SettingsMockStates["ADD_FUNDS_SUCCESS"] = "addFundsSuccess";
})(SettingsMockStates || (exports.SettingsMockStates = SettingsMockStates = {}));
